import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

// Use relative URL so API calls go to same domain as frontend (works on both preview and custom domain)
const API = '/api';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment - use window.location for reliability
        const hash = window.location.hash || location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL. Hash:', hash);
          navigate('/login', { state: { error: 'Ingen session_id fundet i URL' } });
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing session_id:', sessionId.substring(0, 10) + '...');
        console.log('Origin:', window.location.origin);

        // Exchange session_id for session token (no credentials needed for initial exchange)
        const response = await axios.get(`${API}/auth/session`, {
          params: { session_id: sessionId }
        });

        console.log('Auth successful, storing session token');
        
        // Store session token in localStorage for reliable cross-page persistence
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
        }
        
        // Clear the hash from URL before navigating
        window.history.replaceState(null, '', window.location.pathname);
        
        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          state: { user: response.data },
          replace: true 
        });

      } catch (error) {
        console.error('Auth callback error:', error);
        let errorMessage = 'Authentication failed';
        if (error.response) {
          // Server responded with an error
          const detail = error.response.data?.detail;
          errorMessage = typeof detail === 'string' ? detail : 
                        typeof detail === 'object' ? JSON.stringify(detail) :
                        `Server error (${error.response.status})`;
        } else if (error.request) {
          // Request was made but no response received (network/CORS error)
          errorMessage = 'Ingen svar fra server - tjek netværksforbindelse';
        } else {
          errorMessage = error.message || 'Ukendt fejl';
        }
        navigate('/login', { state: { error: errorMessage } });
      }
    };

    processAuth();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-[#0B0C10] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#66FCF1] border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
        <p className="text-[#66FCF1] font-heading text-lg tracking-wider mb-2">
          AUTHENTICATING
        </p>
        <p className="text-[#C5C6C7] font-mono text-sm">
          Verifying your credentials...
        </p>
      </div>
    </div>
  );
};
